/** @typedef	{import('./Props').default} Props */

import { BaseSVG } from '../../BaseSVG';
import { translate } from '../../../App/Internationalization';
import ExternalAnchorButton from '../../ExternalAnchorButton';
import images from '../../../config/local/images';
import React from 'react';
import SubscribeButton from '../SubscribeButton';
import SubscriptionPoints from '../SubscriptionPoints';
import SubscriptionPrice from '../SubscriptionPrice/SubscriptionPrice';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function PremiumSubscriptionCard(props) {
	const plan = props.tier?.title;

	return (
		<section className="flex flex-col gap-2 lg:grid lg:grid-cols-3 lg:gap-28 lg:col-span-full border border-theme-dark rounded-lg w-full p-10 lg:h-fit">
			<div className="flex flex-col items-center">
				<p className="flex justify-center font-bold text-ms-4">
					{translate(
						`subscription.plans.${props?.tier?.title}.title`
					)}
				</p>
				<i
					className={`flex ${
						plan === 'professional' ? 'w-25' : 'w-48'
					} icon p-1 m-3`}
				>
					<BaseSVG
						path={
							images.icons.subscriptionPlans[props?.tier?.title]
						}
					/>
				</i>
				{plan === 'enterprise' ? (
					<ExternalAnchorButton
						className="button w-full p-3 text-ms-3"
						href="https://share.hsforms.com/1D5IxINT8TqOtqs86wkWVuAe0kgx"
						target="_blank"
					>
						{translate('subscription.plans.contact_us')}
					</ExternalAnchorButton>
				) : (
					<SubscribeButton
						checkoutRole={props?.checkoutRole}
						effectiveTierValue={props?.effectiveTierValue}
						groupTierFloor={props?.groupTierFloor}
						groupId={props?.groupId}
						hasExistingSubscription={props?.hasExistingSubscription}
						isGettingData={props?.isGettingData}
						lastPlanChange={props?.lastPlanChange}
						onPlanChanged={props?.onPlanChanged}
						paymentLinks={props?.paymentLinks}
						subscription={props?.subscription}
						tier={props?.tier}
					/>
				)}
			</div>

			<div className="flex flex-col gap-5">
				{plan === 'enterprise' ? null : (
					<div className="flex justify-center">
						<SubscriptionPrice
							checkoutRole={props?.checkoutRole}
							price={props?.tier?.pricePerMonth}
						/>
					</div>
				)}
				<p className="lg:min-h-[7rem] font-medium mb-4">
					{props?.tier?.description}
				</p>
			</div>

			<div>
				{translate('subscription.plans.additional_features')}
				<SubscriptionPoints features={props?.tier?.features} />
			</div>
		</section>
	);
}

export default React.memo(PremiumSubscriptionCard);
